import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  RadarController,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
} from 'chart.js'

Chart.register(
  RadarController,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler
)

export default class extends Controller {
  static values = { data: String }
  
  connect() {
    this.createChart()
  }

  createChart() {
    if (!this.dataValue) {
      console.error('Data value is required for radar chart')
      return
    }

    try {
      const data = JSON.parse(this.dataValue)
      const chartData = [
        parseFloat(data[0]),
        parseFloat(data[1]),
        parseFloat(data[2]),
        parseFloat(data[3]),
        parseFloat(data[4]),
      ]

      // キャンバス要素を作成
      const canvas = document.createElement('canvas')
      this.element.appendChild(canvas)

      const config = {
        type: 'radar',
        data: {
          labels: ['', '', '', '', ''], // デザインの再現を優先しhtml/cssで配置するため空で指定
          datasets: [{
            data: chartData,
            backgroundColor: 'rgba(0, 163, 148, 0.5)', // #00A394 with 50% opacity
            borderColor: '#00A394',
            borderWidth: 0,
            pointRadius: 0,
            pointHoverRadius: 0,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          },
          scales: {
            r: {
              min: 0,
              max: 5,
              angleLines: {
                display: false,
              },
              grid: {
                display: false,
              },
              pointLabels: {
                display: false,
              },
              ticks: {
                display: false,
              },
            }
          },
          interaction: {
            intersect: false,
          },
          elements: {
            line: {
              borderWidth: 0,
            }
          }
        }
      }

      this.chart = new Chart(canvas, config)
    } catch (error) {
      console.error('Failed to create radar chart:', error)
    }
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }
}
